<template>
  <div class="bar-container d-flex align-end align-self-end mb-n1">
    <div v-for="index in 3" class="bar d-flex flex-column" :key="index">
      <div class="bar-head" :style="{ color: color }"></div>
      <div class="bar-body" :class="[`index--${index}`]" :style="{ color: color }"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Loader',
    props: {
      color: {
        type: String,
        default: '#8DE2D5'
      },
    },
  }
</script>

<style lang="scss" scoped>
.bar-container {
  height: 30px;
}
.bar {
  width: 5px;
  margin-right: 5px;
  &:last-child{
    margin-right: 0;
  }
  .bar-head {
    background-color: currentColor;
    height: 5px;
    border-radius: 5px;
    margin-bottom: 3px;
  }
  .bar-body {
    background-color: currentColor;
    height: 5px;
    border-radius: 2px;
    animation: bodyGrowing 1s infinite;
    &.index--1 {
      animation-delay: -.5s;
    }
    &.index--2 {
      animation-delay: .25s;
    }
  }
}

@keyframes bodyGrowing {
  0% {
    height: 5px;
  }
  50% {
    height: 12px;
  }
  100% {
    height: 5px;
  }
}
</style>